import { Download } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import { eHoaDonDienTuActionsObj } from "../../action-types/hoa-don/IHoaDonDienTuAction";
import { generateActionForKey, generateActions } from "../generateActions";

export const hoaDonDienTuActions = {
  ...generateActions(eHoaDonDienTuActionsObj, "HOA_DON_DIEN_TU"),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_MULTIPLE_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_MULTIPLE_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "HUY_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "HUY_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "DIEU_CHINH_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "DIEU_CHINH_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "VIEW_DETAIL_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_HOA_DON_SUCCESS",
    (data: string) => {
      Download.Pdf(data, "hoa_don_dien_tu");
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_HOA_DON_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PREVIEW_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_NHAP_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "PHAT_HANH_NHAP_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "SYNC_STATUS_SUCCESS",
    (m: string) => {
      NotifyHelper.Success(m ?? "Thành công");
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "SYNC_STATUS_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_EXCEL_CHON_XUAT_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_EXCEL_CHON_XUAT_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_EXCEL_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eHoaDonDienTuActionsObj,
    "HOA_DON_DIEN_TU",
    "EXPORT_EXCEL_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
